import { addTariffPdfDownloadAPI, createTariffTemplateAPI, deleteTariffTemplateAPI, getTariffPdfDataAPI, getTariffTemplateAPI, liveShareTariffTemplateAPI, updateTariffTemplateAPI } from "./api";

export const createTariffTemplate = (params, data) => {
    return new Promise((resolve, reject) => {
        createTariffTemplateAPI(params, data)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const addTariffPdfDownload = (data) => {
    return new Promise((resolve, reject) => {
        addTariffPdfDownloadAPI(data)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getTariffPdfData = (params) => {
    return new Promise((resolve, reject) => {
        getTariffPdfDataAPI(params)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}
export const getTariffTemplate = (params) => {
    return new Promise((resolve, reject) => {
        getTariffTemplateAPI(params)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const updateTariffTemplate = (params, data) => {
    return new Promise((resolve, reject) => {
        updateTariffTemplateAPI(params, data)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const deleteTariffTemplate = (params) => {
    return new Promise((resolve, reject) => {
        deleteTariffTemplateAPI(params)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const liveShareTariffTemplate = (params, data) => {
    return new Promise((resolve, reject) => {
        liveShareTariffTemplateAPI(params, data)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

